let dirPath = 'static/games/page011_game3';

let configGame = {
  removeInCorrects: true,
  correctBlock: true,
  //autoCheckAllCorrect: true,
  rulesGame: {
    itemsConfig: {
      block: true,
    },
    otherProperty: {
      sounds: [{ src: dirPath + '/audio/klik.mp3', id: 'mouseup' }],
    },
    items: [
      {
        idGroup: 'mapa',
        idItem: 'legend',
        itemsConfig: {
          shuffle: true,
        },
        items: [
          {
            idGroup: 'source',
            idItem: '00',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook0' }],
          },
          {
            idGroup: 'source',
            idItem: '01',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook1' }],
          },
          {
            idGroup: 'source',
            idItem: '02',
            correct: [{ idGroup: 'mapa', idItem: 'legend', idHook: 'hook2' }],
          },
        ],
      },
    ],
  },
  layout: {
    itemsConfig: {
      positions: {
        margin: { left: 5, bottom: 5 },
      },
      background: {
        color: 'transparent',
        text: { textAlign: 'center', bold: true },
      },
    },
    groups: [
      {
        idGroup: 'mapa',
        background: {
          color: 'transparent',
          //     color: 'pink',
        },
        positions: {
          type: 'absolute',
          pos: { x: 100, y: 0, height: 750, width: 1700 },
        },
        items: [
          {
            id: 'legend',
            positions: {
              autoFit: true,
            },
            otherProperty: {
              hooks: {
                background: {
                  color: '#21212101',
                },
                positions: {
                  type: 'absolute',
                  pos: { height: 55, width: 213 },
                },
                items: [
                  {
                    id: 'hook0',
                    positions: { pos: { x: 1112 - 76, y: 472 + 102, height: 121, width: 183 } },
                  },
                  {
                    id: 'hook1',
                    positions: { pos: { x: 945 - 76, y: 353 + 102, height: 117, width: 137 } },
                  },
                  {
                    id: 'hook2',
                    positions: { pos: { x: 409 - 76, y: 533 + 102, height: 59, width: 342 } },
                  },
                ],
              },
            },
          },
        ],
      },
      {
        idGroup: 'source',
        background: {
          color: 'transparent',
        },
        positions: {
          type: 'absolute',
          pos: { x: 600, y: 50 },
          autoFit: true,
        },
        itemsConfig: {
          positions: {
            pos: { height: 55, width: 213 },
            margin: { right: 10 },
          },
        },
        items: [
          {
            id: '00',
            positions: {
              pos: { height: 121, width: 183 },
            },
            background: {
              image: { src: dirPath + '/img/00.png' },
            },
          },
          {
            id: '01',
            positions: {
              pos: { height: 117, width: 137 },
            },
            background: {
              image: { src: dirPath + '/img/01.png' },
            },
          },
          {
            id: '02',
            positions: {
              pos: { height: 59, width: 342 },
            },
            background: {
              image: { src: dirPath + '/img/02.png' },
            },
          },
        ],
      },
    ],
  },
};

let dataConfig = {
  mixinEngine: 'dnd',
  // isDev: true,
  //   defaultConfig: dirPath + '/defaultConfig.json',
  //   realHeight: 790,
  //   realWidth: 1820,
  mainImage: {
    imagePath: dirPath + '/img/bgr.png',
    pos: {
      // y: -100,
      // x: 80,
    },
    cssStyle: {
      positions: 'absolute',
      left: '-46px',
      top: '30px',
    },
  },
  configGame: configGame,
};

export default dataConfig;
